var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStashrunBetaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.229,
    height: 18,
    viewBox: "0 0 174.229 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(-13647 -6050)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36695",
    "data-name": "Group 36695",
    transform: "translate(13646.692 6050)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M2.564,17.618H13.011a5.287,5.287,0,0,0,0-10.574H5.95a1.392,1.392,0,1,1,0-2.785h10.1a1.938,1.938,0,0,0,0-3.877H5.586a5.274,5.274,0,1,0,0,10.547h7.089a1.392,1.392,0,1,1,0,2.785H2.564a1.947,1.947,0,1,0,0,3.895Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M36.61,2.311A1.946,1.946,0,0,0,34.672.373h-13.5a1.938,1.938,0,0,0,0,3.877h4.8V15.816a1.957,1.957,0,1,0,3.913,0V4.25h4.778A1.946,1.946,0,0,0,36.6,2.311Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M51.6,17.768a1.961,1.961,0,0,0,1.959-1.959V8.748a8.688,8.688,0,0,0-17.376,0v7.06a1.959,1.959,0,1,0,3.918,0V13.363l1.25.411c.035.01.088.026.16.043.138.035.369.09.68.143a15.65,15.65,0,0,0,2.679.218,15.476,15.476,0,0,0,2.679-.218c.311-.055.542-.109.68-.143l.16-.043h.007l.064-.035h.035l1.143-.376V15.81a1.961,1.961,0,0,0,1.959,1.959ZM49.057,9.617a10.625,10.625,0,0,1-4.188.68,10.624,10.624,0,0,1-4.188-.68.982.982,0,0,1-.58-.9,4.769,4.769,0,0,1,9.539,0,.982.982,0,0,1-.58.9Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M57.332,17.617H67.779a5.287,5.287,0,1,0,0-10.574H60.718a1.392,1.392,0,0,1,0-2.785h10.1a1.938,1.938,0,0,0,0-3.877H60.345a5.278,5.278,0,1,0,0,10.556h7.089a1.392,1.392,0,1,1,0,2.785H57.323a1.947,1.947,0,0,0,0,3.895Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M145.112,18a5.282,5.282,0,0,0,5.278-5.278V1.938a1.938,1.938,0,0,0-3.877,0v10.72a1.392,1.392,0,1,1-2.784,0V5.287a5.287,5.287,0,0,0-10.575,0V15.734a1.947,1.947,0,0,0,3.895,0V5.314a1.393,1.393,0,0,1,2.785,0v7.4a5.282,5.282,0,0,0,5.278,5.278Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M90.329,17.772A1.979,1.979,0,0,0,92.3,15.8V2.038a1.97,1.97,0,1,0-3.94,0V7.071H78.845V2.029a1.957,1.957,0,0,0-3.913,0V15.816a1.957,1.957,0,1,0,3.913,0V10.947h9.519V15.8A1.977,1.977,0,0,0,90.329,17.772Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M115.864.063a1.96,1.96,0,0,0-1.957,1.957V9.236a8.7,8.7,0,0,0,8.691,8.691,8.7,8.7,0,0,0,8.69-8.691v-7.2a1.975,1.975,0,0,0-3.949.009V9.282a4.759,4.759,0,0,1-9.519,0V2.029A1.959,1.959,0,0,0,115.864.073Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M106.281,17.6h4.368a1.938,1.938,0,1,0,0-3.877h-4.34a1.392,1.392,0,1,1,0-2.785h1.328a4.49,4.49,0,0,0,4.487-4.486v-.8c0-2.785-2.457-5.6-7.144-5.6A10.886,10.886,0,0,0,94.105,10.929v4.723a2.12,2.12,0,0,0,4.241,0l.018-4.332a7.093,7.093,0,0,1,7.08-7.053h1.4a1.392,1.392,0,0,1,0,2.785h-1.338a4.51,4.51,0,0,0-4.505,4.5v.773a5.282,5.282,0,0,0,5.278,5.278Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BETA",
    transform: "translate(13799.887 6050)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M.113,6.043V0H2.427A2.53,2.53,0,0,1,3.516.207a1.456,1.456,0,0,1,.652.558,1.5,1.5,0,0,1,.218.8,1.313,1.313,0,0,1-.142.631,1.191,1.191,0,0,1-.381.422,1.611,1.611,0,0,1-.534.233v.059a1.309,1.309,0,0,1,.617.2,1.371,1.371,0,0,1,.487.5,1.536,1.536,0,0,1,.189.785,1.6,1.6,0,0,1-.227.844,1.546,1.546,0,0,1-.685.587,2.7,2.7,0,0,1-1.151.215Zm1.095-.915H2.385A1.3,1.3,0,0,0,3.244,4.9a.746.746,0,0,0,.266-.59A.9.9,0,0,0,3,3.485a1.255,1.255,0,0,0-.584-.127H1.208Zm0-2.558H2.291a1.22,1.22,0,0,0,.51-.1.86.86,0,0,0,.357-.3.8.8,0,0,0,.133-.46.75.75,0,0,0-.248-.578A1.037,1.037,0,0,0,2.315.9H1.208Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M5.824,6.043V0h3.93V.918H6.919V2.558H9.551v.918H6.919V5.126H9.778v.918Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M10.855.918V0h4.822V.918H13.809V6.043H12.723V.918Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M16.9,6.043H15.733L17.86,0h1.351l2.13,6.043H20.173l-1.614-4.8h-.047Zm.038-2.37h3.187v.879H16.939Z",
    fill: "#fafafa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStashrunBetaLogo);
export default __webpack_public_path__ + "static/media/Stashrun-beta-logo.ba2dbb99caed2fb4bfdfc829a1287e4d.svg";
export { ForwardRef as ReactComponent };